import copy from 'fast-copy';

import { Component, inject, OnInit } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ModalClosedReason, ModalContent } from '@ap/modal';
import { ApSignComponent } from '@ap/sign';

import content from './sign.content.json';
import { SignOptions } from './sign.model';

/**
 * @module SignModule
 * @ngdoc component
 * @name SignComponent
 */
@Component({
    selector: 'mijn-omgeving-sign',
    templateUrl: 'sign.component.html',
    imports: [ApSignComponent, ApContentPipe]
})
export class SignComponent extends ModalContent<SignOptions> implements OnInit {
    private readonly apContentService: ApContentService = inject(ApContentService);
    public signOptions: SignOptions;

    constructor() {
        super();
    }

    public ngOnInit(): void {
        this.apContentService.addContentItems(content);
        this.signOptions = copy(this.modalOptions.options);
    }

    public onRetry(): void {
        this.close(ModalClosedReason.DECLINED);
    }

    public doneSigning(): void {
        this.close(ModalClosedReason.ACCEPTED);
    }

    public navigateBack(): void {
        this.close(ModalClosedReason.DECLINED);
    }
}
